import { CustomEventWithDetail, CustomEventWithoutDetail } from 'rune-ts';
import {
  CreatorProductData,
  MODE,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';

export class DeleteDateEvent extends CustomEventWithoutDetail {}

export class SelectCheckBoxEvent extends CustomEventWithDetail<{ name: string; checkbox_ids: number[] }> {}

export class ChangeModeEvent extends CustomEventWithDetail<{ mode: MODE; data: CreatorProductData }> {}
